import type { ContentOperationsFragment$data } from '@confluence/entity-operations/entry-points/ContentOperationsFragmentData.ts';
import { OperationTypes } from '@confluence/entity-operations/entry-points/operationsTypes.ts';

export const getCanAddCommentsFromContentOperations = (
	contentOperations: ContentOperationsFragment$data,
): boolean =>
	contentOperations.operations?.some(
		(operation) =>
			operation?.operation === OperationTypes.CREATE && operation?.targetType === 'comment',
	) ?? false;
